// removed by extract-text-webpack-plugin
module.exports = {"trending":"TopStories__trending--MLOxP","content":"TopStories__content--3hCQq","unread":"TopStories__unread--2TuS9","section":"TopStories__section--1t5W8","smarterFaster":"TopStories__smarterFaster--2jOK5","tag":"TopStories__tag--D715d","bounce":"TopStories__bounce--2B7gq"};


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/components/TopStories/TopStories.css
// module id = ./src/dashboard/components/TopStories/TopStories.css
// module chunks = 4